import { Site } from '@envato/foundation-types'

import { getConfigBySite } from '../../../config/sites'
import { Consent, consented } from '../consent'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../localStorageHelpers'

const itemKey = (site: Site) => {
  return `${site}-search-page-views`
}

export const shouldTrackSearchCount = (site: Site) => {
  return !!getConfigBySite(site, 'surveys.search')
}

export const searchesCount = (site: Site) =>
  consented(Consent.statistics) ? getLocalStorageItem(itemKey(site), 0) : 0

export const countSearchFor = (site: Site) => {
  if (consented(Consent.statistics)) {
    const newCount = getLocalStorageItem(itemKey(site), 0) + 1
    setLocalStorageItem(itemKey(site), newCount)
  }
}
